import { render } from "./selectLessonFile.vue?vue&type=template&id=53e5e520"
import script from "./selectLessonFile.vue?vue&type=script&lang=js"
export * from "./selectLessonFile.vue?vue&type=script&lang=js"

import "./selectLessonFile.vue?vue&type=style&index=0&id=53e5e520&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__